<template>
  <div class="synchronous">
    <div class="synchronous-header">
      <div>
        <el-button type="primary" @click="handelAddCouponBtn">同步抖店商品券</el-button>
        <span class="synchronous-header-tip">点击该按钮后，手动同步对应抖店ID的商品到我们自己数据库，主要同步列表信息和商品适用门店。</span>
      </div>
      <div class="forms-container">
        <el-form :rules="rulesSearch" :model="searchForm" class="search-form" ref="searchFormRef">
          <el-form-item label="券名称" prop="productName">
            <el-input
              style="width:200px"
              :maxlength="255"
              v-model="searchForm.productName"
              placeholder="券名称"
            />
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select v-model="searchForm.productStatus" placeholder="请选择上架状态">
              <el-option
                v-for="item in productStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="抖店商品ID"
            prop="productId"
          >
            <el-input
              style="width:170px"
              :maxlength="255"
              v-model="searchForm.productId"
              placeholder="抖店商品ID"
            />
          </el-form-item>
          <el-form-item>
            <!-- 操作按钮 -->
            <el-button type="warning" @click="onFormSearch">查询</el-button>
            <el-button type="warning" plain @click="onFormReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <my-table
      :tableData="table.tableData"
      :headerList="table.headerList"
      :loading="table.loading"
      :page-size="params.pageSize"
      :currentPage="params.pageNo"
      :total="table.total"
      @currentPage-change="handlePageChange"
      @sizePage-change="handleSizeChange"
    >
      <!-- 自定义内容 -->
      <template v-slot:syncStatus="{ data }">
        <el-tag v-if="data.syncStatus === 0" size="small">同步中</el-tag>
        <el-tag v-if="data.syncStatus === 1" size="small" type="success">同步成功</el-tag>
        <el-tag v-if="data.syncStatus === 2" size="small" type="danger">同步失败</el-tag>
      </template>
      <template v-slot:operation="{ data }">
        <div v-if="data.syncStatus === 0" style="color:#999999;cursor: not-allowed;">更新商品信息</div>
        <div v-else class="table-link" @click="handelOperation({data})">更新商品信息</div>
      </template>
    </my-table>
    <addCoupon ref="addCouponRef" @submit="handelSubmit"></addCoupon>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import myTable from '@/components/my-table.vue'
import addCoupon from "./component/addCoupon.vue";
import debounce from "@/utils/debounce.js";
export default {
  components:{
    myTable,
    addCoupon,
  },
  data() {
    return {
      searchForm:{
        productName:'',
        productStatusStr:'',
        productId:''
      },
      params:{
        pageNo:1,
        pageSize:10,
      },
      table:{
        loading:false,
        total:0,
        tableData: [],
        headerList:[
          {
            prop: 'syncTimeStr',
            label: '同步时间',
            width: '170',
            // customRender:'customName'
          },
          {
            prop: 'productName',
            label: '券商品名称',
            width: '180'
          },
          {
            prop: 'productStatusStr',
            label: '商品状态',
            width: '100'
          },
          {
            prop: 'shopName',
            label: '所属店铺',
            width: '180'
          },
          {
            prop: 'productId',
            label: '抖店商品ID',
            width: '230',
          },
          {
            prop: 'sellerPriceBd',
            label: '售价（元）',
            width: '100'
          },
          {
            prop: 'createTime',
            label: '上架时间',
            width: '170',
          },
          {
            prop: 'updateTime',
            label: '修改时间',
            width: '170'
          },
          {
            prop: 'sellNum',
            label: '销量',
            width: '120',
          },
          {
            prop: 'syncStatus',
            label: '同步状态',
            width: '120',
            customRender:'syncStatus'
          },
          {
            prop: 'operation',
            label: '操作',
            width: '120',
            customRender: 'operation',
            fixed: 'right'
          }
        ]
      },
      productStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已上架",
          value: 1,
        },
        {
          label: "已下架",
          value: 2,
        },
        {
          label: "已售罄",
          value: 3,
        },
        {
          label: "已删除",
          value: 5,
        },
      ],
      rulesSearch:{
        productId: [
          { validator: this.validateNumber, trigger: 'blur' } // 自定义校验规则
        ]
      }
    }
  },
  created() {
    this.getksLifeCouponQueryList()
  },
  methods:{
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getksLifeCouponQueryList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(()=> {
        this.searchForm = {
          productName:'',
          productStatus:'',
          productId:''
        }
        this.$refs['searchFormRef'].resetFields();
        this.getksLifeCouponQueryList()
      },1000,true)
    },
    reset() {
      this.params = {
        pageNo:1,
        pageSize:10,
      }
      this.getksLifeCouponQueryList()
    },
    // 抖音商品券同步-列表
    async getksLifeCouponQueryList(){
      let appKeyMini = localStorage.getItem("appKeyMini");
      this.table.loading = true;
      const res = await MiniModel.ddCouponGoodsPageV3({...this.params,...this.searchForm,miniAppKey:appKeyMini}).finally(()=>{
        this.table.loading = false;
      })
      console.log(res,'抖音商品券同步-列表')
      if(res.data.code === 200) {
        this.table.tableData = res.data.data.list.map(item => {
          return {
            ...item,
          }
        })
        this.table.total = res.data.data.total;
        this.params.pageNo = res.data.data.pageNo
        console.log(this.table.tableData,'this.table.tableData')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    async handelOperation(row){
      console.log(row,'row')
      this.getKsLifeCouponCoupon(row.data.productId)
    },
    // 更新抖音商品券
    async getKsLifeCouponCoupon(data) {
      let appKeyMini = localStorage.getItem("appKeyMini");
      const res = await MiniModel.dyUpdateGoodInfoV3({productId:data,miniAppKey:appKeyMini})
      if(res.data.code === 200) {
        this.$message({
          message: res.data.message,
          type: 'success'
        });
        this.getksLifeCouponQueryList()
      }else{
        // // 新增未查到id
        // if(res.data.code === -100 && type === 1) {
        //   this.$refs.addCouponRef.handelNotFindId(res.data.data)
        // }
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    handelAddCouponBtn() {
      this.$refs.addCouponRef.openDialog()
    },
    handelSubmit() {
      this.params.pageNo = 1
      this.getksLifeCouponQueryList()
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getksLifeCouponQueryList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getksLifeCouponQueryList()
    },
  }
}
</script>

<style scoped lang="less">
.synchronous{
  &-header{
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    &-tip{
      color: #666;
      margin-left: 10px;
      font-size: 12px;
    }
    &__icons{
      i{
        font-size: 22px;
        cursor: pointer;
        margin-right: 50px;
        color: #409eff;
      }
    }
  }
}
.forms-container{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ksCouponExchange/ddCouponSynchronization/index.vue